// The RBP Shopping List's "Last Edited" (RBP-D18). SL1.0 shows the store's last selection change,
// and with no selection the acting user's last RBP add to cart in the same sign-in
// (`$ui['RbpNpr_LastCartEdited']`, written into the PHP session by the add, RULE-014, RULE-015).
// The api is stateless, so the sign-in value is the SPA's: sessionStorage (it survives a reload
// and goes with the tab), cleared on sign-out. The RBP add to cart writes it after a successful
// add; until that exists the fallback stays blank. Every access is wrapped, so private mode or
// blocked storage just means no fallback.

export const LAST_RBP_ADD_TO_CART_KEY = 'shoplink.rbp.lastAddToCartAt';

const ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;

/** The server's value, else the sign-in add, else null (shown blank). */
export function lastEditedShown(
  serverLastEditedAt: string | null,
  lastRbpAddToCartAt: string | null,
): string | null {
  return serverLastEditedAt ?? lastRbpAddToCartAt ?? null;
}

export function readLastRbpAddToCartAt(): string | null {
  let raw: string | null;
  try {
    raw = window.sessionStorage.getItem(LAST_RBP_ADD_TO_CART_KEY);
  } catch {
    return null;
  }
  return raw !== null && ISO_INSTANT.test(raw) ? raw : null;
}

/** Record a successful RBP add to cart, as a UTC instant (`toISOString()`). */
export function writeLastRbpAddToCartAt(isoInstant: string): void {
  try {
    window.sessionStorage.setItem(LAST_RBP_ADD_TO_CART_KEY, isoInstant);
  } catch {
    // Storage unavailable: the fallback is simply not kept.
  }
}

export function clearLastRbpAddToCartAt(): void {
  try {
    window.sessionStorage.removeItem(LAST_RBP_ADD_TO_CART_KEY);
  } catch {
    // Storage unavailable: nothing to clear.
  }
}
